// extracted by mini-css-extract-plugin
module.exports = {"main":"topphoto_main__1Yu46"};